export default () => ({
  roleCoursePermissions: []
});
